import { useRef, useState,useEffect } from "react";
import Image from "next/image";
import styles from '../../styles/home/BlogCarousel.module.css';
import { ChevronRightIcon } from '../icons/Icon';

const BlogCarousel = ({
  page = page,
  heading,
  subHeading,
  eyebrow = "INDUSTRY INSIGHTS",
  pagePad = false,
}) => {
  const scrollRef = useRef(null);
  const sectionRef = useRef(null);

  const [posts, setPosts] = useState([]);

  // Fetched only once the carousel nears the viewport so this off-screen,
  // below-the-fold section never competes with above-the-fold resources
  // for bandwidth during initial page load.
  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return undefined;

    const getPosts = async () => {
      const res = await fetch(`/api/posts?page=${page}`);
      const data = await res.json();
      setPosts(data.posts);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          getPosts();
          observer.disconnect();
        }
      },
      { rootMargin: '300px' }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [page]);

  const scroll = (direction) => {
    if (!scrollRef.current) return;

    const width = scrollRef.current.clientWidth;

    scrollRef.current.scrollBy({
      left: direction === "left" ? -width : width,
      behavior: "smooth",
    });
  };
  

  return (
    <section className={`${styles.blogSection} ${pagePad ? styles.pagePad : ''}`} ref={sectionRef}>
      <p className={styles.capabilitiesHeading}>{eyebrow}</p>

      <div className={styles.blogContainer}>
        <h2 className={styles.sectionHeading}>{heading}</h2>

        {subHeading && (
          <p className={styles.capabilitiesSubtitle}>{subHeading}</p>
        )}

        <div className={styles.blogCaraouselContainer}>
          <div className={`${styles.nav} ${styles.navLeft}`}>
            <Image
              src="/img/nav-left.svg"
              width={50}
              height={50}
              alt="Previous"
              onClick={() => scroll("left")}
            />
          </div>

          <div className={styles.blogCaraouselContent} ref={scrollRef}>
            {posts.map((post) => (
              <div className={styles.blogItem} key={post.id}>
                <div className={styles.blogImg}>
                  <Image
                    src={post.feature_image}
                    layout="fill"
                    objectFit="cover"
                    objectPosition="center"
                    alt={post.title}
                  />
                </div>

                <div className={styles.blogContent}>
                  {/* {post.primary_tag && (
                    <a
                      href={post.primary_tag.url}
                      className={styles.blogTag}
                    >
                      {post.primary_tag.name}
                    </a>
                  )} */}

                  <p className={styles.blogTitle}>{post.title}</p>

                  <p className={styles.blogText}>{post.excerpt}</p>

                  <a
                    href={post.url}
                    className={styles.blogAction}
                    title={post.title}
                  >
                    Read More
                    <span className="sr-only">
                      about {post.title}
                    </span>{" "}
                    <ChevronRightIcon />
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className={`${styles.nav} ${styles.navRight}`}>
            <Image
              src="/img/nav-right.svg"
              width={50}
              height={50}
              alt="Next"
              onClick={() => scroll("right")}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogCarousel;